<!-- **
* 带上方跳转表格
  * 显示样式参考 空调系统界面
* -->
<template>
  <div
    :class="
      !!className
        ? `${className} alarmTable ashComWrap`
        : `alarmTable ashComWrap`
    "
  >
    <div class="comTitle">
      <h4>{{ titleName }}</h4>
      <el-button
        type="text"
        style="color: #999999"
        @click="$router.push(jumpUrl)"
        >更多 <i class="el-icon-d-arrow-right"></i
      ></el-button>
    </div>
    <div class="comContentBox tableCom">
      <TopTips
        v-if="showTopTips"
        :listData="listData"
        :className="classNameTips"
      />
      <div :class="showTopTips ? 'tabList' : 'tabList tabListFullHeight'">
        <el-table
          :data="tableData"
          height="100%"
          border
          stripe
          style="width: 100%"
          :cell-style="cellStyle"
          :header-cell-style="{
            'font-weight': 'bold',
            color: '#333',
            'background-color': '#F7F7F7',
          }"
          size="small"
        >
          <el-table-column
            v-for="(v, i) in tableDataHead"
            :key="i"
            :prop="v.prop"
            :label="v.label"
            align="center"
            :width="v.label.includes('时间') ? '140' : null"
          >
            <template slot-scope="scope">
              <span
                v-if="
                  ['alarmId', 'id'].includes(v.prop) &&
                  scope.row[v.prop] &&
                  scope.row[v.prop].length >= 10
                "
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row[v.prop]"
                  placement="top-start"
                >
                  <div>{{ scope.row[v.prop] }}</div>
                </el-tooltip>
              </span>
              <span v-else>{{ scope.row[v.prop] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import TopTips from "./TopTips.vue";
export default {
  components: { TopTips },
  name: "TableWithJump",
  props: {
    titleName: {
      type: String,
      default: "报警",
    },
    jumpUrl: {
      type: String|Object,
      default: "/alarmManagement",
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    tableDataHead: {
      type: Array,
      default: () => [],
    },
    listData: {
      type: Array,
      default: () => [],
    },
    colorObj: {
      type: Object,
      default: () => ({
        高危: "#EC5453",
        危险: "#FF9400",
        警告: "#7895EA",
        紧急: "#EC5453",
        重要: "#FF9400",
        一般: "#7895EA",
        安全隐患: "#FA541C",
      }),
    },
    className: {
      type: String,
      default: "",
    },
    classNameTips: {
      type: String,
      default: "",
    },
    showTopTips: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    cellStyle(row) {
      if (row.column.label === "报警级别") {
        switch (row.row.level) {
          case "高危":
            return "color:#EC5453";
            break;
          case "危险":
            return "color:#FF9400";
            break;
          case "警告":
            return "color:#777777";
            break;
          default:
            return "";
        }
      }
      if (row.column.label === "处理状态") {
        if (row.row.confirm == "未确认") {
          return "color:#28CCCB";
        }
      }
      if (row.column.label === "工单级别") {
        switch (row.row.priority) {
          case "紧急":
            return "color:#E31313";
            break;
          case "重要":
            return "color:#FF6600";
            break;
          case "一般":
            return "color:#FFCC00";
            break;
          case "安全隐患":
            return "color:#FA541C";
            break;
          default:
            return "";
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.alarmTable {
  width: 100%;
}

.tableCom {
  .cardList {
    width: 96%;
    height: 65px;
    margin: 0 auto;
    @include setFlexBetween;

    li {
      width: 25%;
      height: 100%;
      @include setFlexColumn;
      align-items: center;
      justify-content: center;

      p {
        color: #333333;
        font-weight: 500;
        margin-bottom: 5px;
      }

      h5 {
        font-size: 20px;
        color: #666666;
        font-weight: 500;
      }
    }
  }

  .tabList {
    width: 96%;
    margin: 10px auto 0;
    height: calc(100% - 75px);

    ::v-deep .cell {
      // padding-left: 8px;
      // padding-right: 8px;
      .el-tooltip {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        word-break: break-all;
      }
    }
  }
  .tabListFullHeight {
    height: calc(100% - 10px);
  }
}
</style>
